<template>
  <div>
    <div v-if="displayIntro" class="text-container md:md-text-container">
      <div class="grid grid-cols-1 md:grid-cols-10 gap-5">
        <div class="md:col-span-8">
          <Heading text="And now breathe"/>
        </div>
        <div class="md:col-span-8">
          We will now take you through a short breathing exercise to help you feel relaxed and
          calm.
        </div>
        <div class="md:col-span-8">
          Please breathe in time with the animation.
        </div>
        <div class="md:col-span-8">
          After this we’ll be asking you about your Happy Place...
        </div>
        <div class="md:col-span-8">
          <Button v-bind:onClick="startExercise" text="Continue"/>
        </div>
      </div>
      <audio ref="aud" src="@/assets/audio/breathing.mp3" />
    </div>
    <div v-else class="breathing-container">
      <div class="breathing">
        <div class="breathing-image-container md:md-breathing-image-container">
          <img class="breathing-image" src="@/assets/images/breathing.jpg"/>
        </div>
        <div>
          Breathe in time with the animation
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import Heading from '@/components/Heading.vue';

export default {
  name: 'Breathing',
  components: {
    Button,
    Heading,
  },
  data() {
    return {
      displayIntro: true,
      instruction: 'Breathe in',
      instructionInterval: null,
      timeoutInterval: null,
    };
  },
  methods: {
    setInstruction() {
      if (this.instruction === 'Breathe in') {
        this.instruction = 'Breathe out';
      } else {
        this.instruction = 'Breathe in';
      }
    },
    startExercise() {
      this.$refs.aud.pause();
      this.displayIntro = false;
      this.instructionInterval = setInterval(() => {
        this.setInstruction();
      }, 6000);
      this.timeoutInterval = setInterval(() => {
        clearInterval(this.instructionInterval);
        clearInterval(this.timeoutInterval);
        this.$store.commit('setView', 'LetsBegin');
      }, 28000);
    },
  },
  mounted() {
    this.$refs.aud.play();
  },
};
</script>

<style scoped>
@keyframes throb {
  0%   {width: 100%;}
  20%  {width: 50%;}
  40%  {width: 100%;}
  60%  {width: 50%;}
  80%  {opacity: 1; width: 100%;}
  100% {opacity: 0;}
}

.breathing {
  align-self: center;
  width: 100%
}

.breathing-image {
  animation: throb 28.8s;
  margin: auto;
}

.breathing-image-container {
  display: flex;
  height: 90vw;
  margin: auto;
  width: 90vw;
}

.breathing-container {
  align-content: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: auto;
  width: 100vw;
}

.continue-button {
  background-color: #5e5b5c;
  border-radius: 2rem;
  bottom: 8vh;
  color: #fff;
  font-size: .75rem;
  font-weight: 500;
  padding: .25em 1.75em;
  position: absolute;
  text-transform: uppercase;
}

@responsive {
  .md-breathing-image-container{
    height: 35vw;
    width: 35vw;
  }
}
</style>
